import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUser from "./user/reducers/user.reducer";
import * as fromWindowDetail from './ui/window/reducers/window-detail.reducer'
import * as fromOrderUI from './ui/order/reducers/order-ui.reducer';
import * as fromHomePageUI from './ui/home page/reducers/home-page.reducer'
import * as fromProductUI from './ui/product/reducers/product-ui.reducer';

export const selectOrderUIState = createFeatureSelector<fromOrderUI.State>(
    fromOrderUI.orderUiFeatureKey
);

export const selectProductUIState = createFeatureSelector<fromProductUI.State>(
    fromProductUI.productUiFeatureKey
);

export const selectUserState = createFeatureSelector<fromUser.State>(
    fromUser.userFeatureKey
);

export const selectWindowDetailState = createFeatureSelector<fromWindowDetail.State>(
    fromWindowDetail.windowDetailFeatureKey
)

export const selectHomePageUIState = createFeatureSelector<fromHomePageUI.State>(
  fromHomePageUI.homePageFeatureKey
)
